import {
  fontWeightClass,
  getInputClass,
  getInputClassCustomized,
} from "~/assets/styles/classes/InputClasses";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";

interface SIMPLInputTextProps {
  name: string;
  value: string;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  id: string;
  label?: string;
  type?: string;
  fontWeight?: "bold" | "normal" | "extrabold";
  placeholder?: string;
  required?: boolean;
  errorLabel?: string;
  disabled?: boolean;
  hideLabel?: boolean;
  borderClass?:
    | "rounded-none"
    | "rounded-sm"
    | "rounded"
    | "rounded-md"
    | "rounded-lg"
    | "rounded-xl"
    | "rounded-2xl"
    | "rounded-3xl";
  onClick?: () => void;
  readOnly?: boolean;
  autoFocus?: boolean;
  rows?: number;
  testId?:string
}

export const SIMPLInputTextCustumized = ({
  name,
  value,
  onChange,
  id,
  label,
  fontWeight = "normal",
  type = "text",
  required = false,
  placeholder,
  errorLabel,
  disabled = false,
  hideLabel = false,
  borderClass = "rounded-lg",
  readOnly = false,
  onClick,
  autoFocus = false,
  rows,
  testId
}: SIMPLInputTextProps) => {
  const getInputElement = () => {
    switch (type) {
      case "textarea":
        return (
          <textarea
            name={name}
            value={value}
            onChange={onChange}
            onClick={onClick}
            autoFocus={autoFocus}
            rows={rows}
            className={`${getInputClass(borderClass, errorLabel, readOnly)} resize-y min-h-10 max-h-44 h-full text-area-input ${errorLabel ? "placeholder:text-red-500" : "placeholder:text-[#6B6F7B]"}`}
            id={id}
            readOnly={readOnly}
            placeholder={placeholder}
            disabled={disabled}
            data-test-id={testId}
          />
        );
      default:
        return (
          <input
            name={name}
            value={value}
            onChange={onChange}
            type={type}
            onClick={onClick}
            autoFocus={autoFocus}
            className={`${getInputClassCustomized(borderClass, errorLabel, "",readOnly)} ${errorLabel ? "placeholder:text-[#CA3532]" : ""}`}
            id={id}
            readOnly={readOnly}
            placeholder={placeholder}
            disabled={disabled}
            data-test-id="SimplTextCustumizedId"
          />
        );
    }
  };

  return (
    <div>
      {!hideLabel && (
        <label
          htmlFor={id}
          className={`inline-flex items-center gap-1 cursor-pointer text-sm ${fontWeightClass(fontWeight)} ${errorLabel ? "text-error" : ""}`}
        >
          {required && <span className="text-red-500">*</span>}
          <span>{label}</span>
        </label>
      )}
      <div className="relative flex flex-wrap items-stretch h-full">
        {getInputElement()}
      </div>
      {errorLabel && (
        <div className="flex items-baseline space-x-1 mt-1">
          <span className="flex items-center justify-center w-4 h-4 text-error translate-y-[1px]">
            <HighlightOffRoundedIcon
              fontSize="small"
              sx={{ width: 16, height: 16 }}
            />
          </span>
        </div>
      )}
    </div>
  );
};
